import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'global-connect-app-dialog',
  templateUrl: 'global-connect-app-dialog.html',
  styleUrls: ['./global-connect-app-dialog.scss']
})
export class GlobalConnectAppDialog {

  public store: string;
  public qrCodeUrl: string;
  public extension: string;

  constructor(
    public translationService: TranslationService,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.store = data.store;
    this.qrCodeUrl = data.qrCodeUrl;
    this.extension = data.extension;
  }
}
